import { ArrowLeftCircleIcon } from "@heroicons/react/24/outline";
import { useLocation, useNavigate } from "react-router-dom";
import { useLoadInviteDetails } from "../hooks/useLoadInviteDetails";
import { SubmitButton } from "./shared/buttons/submit-button";
import Card from "./shared/card";
import Typography from "./shared/typography";

function InviteClaimBox() {
  const location = useLocation();

  const navigate = useNavigate();

  const params = new URLSearchParams(location.search);
  const slug = params.get("invite-slug");

  const { inviteDetails } = useLoadInviteDetails(slug || "");

  if (!slug || !inviteDetails) return null;

  // Don't show on the account page
  if (location.pathname === "/account") return null;

  return (
    <div className="fixed bottom-4 right-4 z-40 w-80">
      <Card variant="cream" elevation={3}>
        <Card.Header variant="cream" className="text-center">
          <Typography variant="h4" className="text-primary">
            Claim Your Account
          </Typography>
        </Card.Header>
        <Card.Body>
          {inviteDetails?.contact?.related_user?.first_name && (
            <Typography variant="body2" className="text-brown-600 mb-2">
              {inviteDetails?.contact?.related_user?.first_name} has invited you
            </Typography>
          )}

          <div className="flex justify-center">
            <SubmitButton
              color="terracotta"
              onClick={() => {
                navigate(`/invite/accept/${slug}`);
              }}
              icon={<ArrowLeftCircleIcon className="w-4 h-4 " color="white" />}
            >
              Claim Account
            </SubmitButton>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}

export default InviteClaimBox;
